import api from '../lib/api';

const usersService = {
  getProfile: () => api.get('/users/profile'),
  updateProfile: (data) => api.put('/users/profile', data),
  getUser: (id) => api.get(`/users/${id}`),
  getFollowStatus: (id) => api.get(`/users/${id}/follow-status`),
  getUserArticles: (id) => api.get(`/users/${id}/articles`),
  followUser: (id) => api.post(`/users/${id}/follow`),
  unfollowUser: (id) => api.delete(`/users/${id}/follow`),
};

export default usersService;
